export const getShortName = str =>
  str
    .split(" ")
    .map((i, key) => (key > 0 ? `${i[0]}.` : i))
    .join(" ");
